import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var FILE_STORAGE_API = 'FILE_STORAGE_API';
export var FileStorageApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(FileStorageApi, _AxiosApi);

  var _super = _createSuper(FileStorageApi);

  function FileStorageApi(axiosInstance) {
    var _this;

    _classCallCheck(this, FileStorageApi);

    _this = _super.call(this, 'file-storage', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(FileStorageApi, [{
    key: "createFormCategoryLogo",
    value: function () {
      var _createFormCategoryLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url, "/form-category-logo");
                formData = new FormData();
                formData.append('formCategoryId', input.formCategoryId);
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function createFormCategoryLogo(_x) {
        return _createFormCategoryLogo.apply(this, arguments);
      }

      return createFormCategoryLogo;
    }()
  }, {
    key: "createFormThumbnail",
    value: function () {
      var _createFormThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/form-thumbnail");
                formData = new FormData();
                formData.append('formId', input.formId);
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context2.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function createFormThumbnail(_x2) {
        return _createFormThumbnail.apply(this, arguments);
      }

      return createFormThumbnail;
    }()
  }, {
    key: "createMarkdownEditorImage",
    value: function () {
      var _createMarkdownEditorImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/markdown-editor-image");
                formData = new FormData();
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                formData.append('formId', input.formId);
                _context3.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));

      function createMarkdownEditorImage(_x3) {
        return _createMarkdownEditorImage.apply(this, arguments);
      }

      return createMarkdownEditorImage;
    }()
  }, {
    key: "createMarkdownEditorAudio",
    value: function () {
      var _createMarkdownEditorAudio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/markdown-editor-audio");
                formData = new FormData();
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                formData.append('formId', input.formId);
                _context4.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 13]]);
      }));

      function createMarkdownEditorAudio(_x4) {
        return _createMarkdownEditorAudio.apply(this, arguments);
      }

      return createMarkdownEditorAudio;
    }()
  }, {
    key: "createTagIcon",
    value: function () {
      var _createTagIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                url = "".concat(this.url, "/tag-icon");
                formData = new FormData();
                formData.append('tagId', input.tagId);
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context5.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context5.sent;
                parsedResponseBody = jsonResponse.data;
                return _context5.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 13]]);
      }));

      function createTagIcon(_x5) {
        return _createTagIcon.apply(this, arguments);
      }

      return createTagIcon;
    }()
  }, {
    key: "updateFile",
    value: function () {
      var _updateFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
        var id, status, url;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                id = input.id, status = input.status;
                url = "".concat(this.url, "/").concat(id);
                _context6.next = 5;
                return this.axiosInstance.patch(url, {
                  status: status.value
                });

              case 5:
                return _context6.abrupt("return", Result.ok());

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function updateFile(_x6) {
        return _updateFile.apply(this, arguments);
      }

      return updateFile;
    }()
  }, {
    key: "createSectionFile",
    value: function () {
      var _createSectionFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                url = "".concat(this.url, "/sections");
                formData = new FormData();
                formData.append('folderId', input.folderId);
                formData.append('formId', input.formId);
                formData.append('sectionId', input.sectionId);
                formData.append('method', input.method); // formData.append('file', input.file);

                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context7.next = 10;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 10:
                jsonResponse = _context7.sent;
                parsedResponseBody = jsonResponse.data;
                return _context7.abrupt("return", Result.ok(parsedResponseBody.data));

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 15]]);
      }));

      function createSectionFile(_x7) {
        return _createSectionFile.apply(this, arguments);
      }

      return createSectionFile;
    }()
  }, {
    key: "createQuestionFile",
    value: function () {
      var _createQuestionFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                url = "".concat(this.url, "/questions");
                formData = new FormData();
                formData.append('folderId', input.folderId);
                formData.append('formId', input.formId);
                formData.append('questionId', input.questionId);
                formData.append('method', input.method); // formData.append('file', input.file);

                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context8.next = 10;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 10:
                jsonResponse = _context8.sent;
                parsedResponseBody = jsonResponse.data;
                return _context8.abrupt("return", Result.ok(parsedResponseBody.data));

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 15]]);
      }));

      function createQuestionFile(_x8) {
        return _createQuestionFile.apply(this, arguments);
      }

      return createQuestionFile;
    }()
  }, {
    key: "createProfileFile",
    value: function () {
      var _createProfileFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                url = "".concat(this.url, "/profile");
                formData = new FormData();
                formData.append('userId', input.userId);
                formData.append('method', input.method); // formData.append('file', input.file);

                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context9.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context9.sent;
                parsedResponseBody = jsonResponse.data;
                return _context9.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 13]]);
      }));

      function createProfileFile(_x9) {
        return _createProfileFile.apply(this, arguments);
      }

      return createProfileFile;
    }()
  }, {
    key: "createQuestionAnswerFile",
    value: function () {
      var _createQuestionAnswerFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                url = "".concat(this.url, "/question-answers");
                formData = new FormData();
                formData.append('folderId', input.folderId);
                formData.append('formId', input.formId);
                formData.append('questionId', input.questionId);
                formData.append('answerId', input.answerId);
                formData.append('method', input.method); // formData.append('file', input.file);

                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context10.next = 11;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 11:
                jsonResponse = _context10.sent;
                parsedResponseBody = jsonResponse.data;
                return _context10.abrupt("return", Result.ok(parsedResponseBody.data));

              case 16:
                _context10.prev = 16;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 16]]);
      }));

      function createQuestionAnswerFile(_x10) {
        return _createQuestionAnswerFile.apply(this, arguments);
      }

      return createQuestionAnswerFile;
    }()
  }, {
    key: "createSubmissionAnswerFile",
    value: function () {
      var _createSubmissionAnswerFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                url = "".concat(this.url, "/submission-answers");
                formData = new FormData();
                formData.append('assignmentId', input.assignmentId);
                formData.append('submissionAnswerId', input.submissionAnswerId);
                formData.append('submissionId', input.submissionId);
                formData.append('method', input.method); // formData.append('file', input.file);

                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context11.next = 10;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 10:
                jsonResponse = _context11.sent;
                parsedResponseBody = jsonResponse.data;
                return _context11.abrupt("return", Result.ok(parsedResponseBody.data));

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", ErrorResultHandler(_context11.t0));

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 15]]);
      }));

      function createSubmissionAnswerFile(_x11) {
        return _createSubmissionAnswerFile.apply(this, arguments);
      }

      return createSubmissionAnswerFile;
    }()
  }, {
    key: "saveFile",
    value: function () {
      var _saveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                url = "".concat(this.url, "/").concat(input.id);
                _context12.next = 4;
                return this.axiosInstance.patch(url);

              case 4:
                jsonResponse = _context12.sent;
                parsedResponseBody = jsonResponse.data;
                return _context12.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", ErrorResultHandler(_context12.t0));

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 9]]);
      }));

      function saveFile(_x12) {
        return _saveFile.apply(this, arguments);
      }

      return saveFile;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                url = "".concat(this.url, "/").concat(input.id);
                _context13.next = 4;
                return this.axiosInstance["delete"](url);

              case 4:
                jsonResponse = _context13.sent;
                parsedResponseBody = jsonResponse.data;
                return _context13.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", ErrorResultHandler(_context13.t0));

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function _delete(_x13) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "createAiAttachmentFile",
    value: function () {
      var _createAiAttachmentFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        var url, formData, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                url = "".concat(this.url, "/form-thumbnail");
                formData = new FormData(); // TODO: Change this to exact ai attachment on file storage.

                formData.append('formId', input.conversationId);
                formData.append('method', input.method);
                formData.append('fileDto', JSON.stringify(input.fileDto, null, 2));
                _context14.next = 8;
                return this.axiosInstance.post(url, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 8:
                jsonResponse = _context14.sent;
                parsedResponseBody = jsonResponse.data;
                return _context14.abrupt("return", Result.ok(parsedResponseBody.data));

              case 13:
                _context14.prev = 13;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", ErrorResultHandler(_context14.t0));

              case 16:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 13]]);
      }));

      function createAiAttachmentFile(_x14) {
        return _createAiAttachmentFile.apply(this, arguments);
      }

      return createAiAttachmentFile;
    }()
  }, {
    key: "validatePublicFileUrl",
    value: function () {
      var _validatePublicFileUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                url = '/file-storage/validate-public-file-url';
                _context15.next = 4;
                return this.axiosInstance.post(url, input);

              case 4:
                jsonResponse = _context15.sent;
                parsedResponseBody = jsonResponse.data;
                return _context15.abrupt("return", Result.ok(parsedResponseBody.data));

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", ErrorResultHandler(_context15.t0));

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 9]]);
      }));

      function validatePublicFileUrl(_x15) {
        return _validatePublicFileUrl.apply(this, arguments);
      }

      return validatePublicFileUrl;
    }()
  }]);

  return FileStorageApi;
}(AxiosApi);